import styled from 'styled-components';

export const Container = styled.span`
  width: ${({ theme }) => theme.spacing['2Xl']};
  height: ${({ theme }) => theme.spacing['2Xl']};
  margin-right: ${({ theme }) => theme.spacing.md};
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

export const RadioButton = styled.input`
  appearance: none;
  outline: none;

  border-radius: ${({ theme }) => theme.borderRadius.round};
  background: ${({ theme }) => theme.background.default};
  ${({ theme }) => theme.innerAlignBorder(theme.border.xs, theme.border.default)}

  width: ${({ theme }) => theme.fontSize['400']};
  height: ${({ theme }) => theme.fontSize['400']};
  margin: 0px;
  padding: 0px;

  &:not(:disabled, :checked):hover {
    ${({ theme }) => theme.innerAlignBorder(theme.border.xs, theme.border.strong)}
  }

  &:not(:disabled, :checked):focus,
  :focus-visible {
    ${({ theme }) => theme.focusBoxShadow(theme.shadow.focusVisible)};
  }

  &:checked {
    ${({ theme }) => theme.innerAlignBorder('6px', theme.background.strong)}
  }
  &:checked:not(:focus, :disabled):hover {
    ${({ theme }) => theme.innerAlignBorder('6px', theme.background.strongHover)}
  }

  &:not(:disabled):checked:focus {
    box-shadow: ${({ theme }) =>
      theme.innerAlignBorder('6px', theme.background.strong, true) +
      ',' +
      theme.focusBoxShadow(theme.shadow.focusVisible, true)};
    color: red;
  }

  &:disabled {
    ${({ theme }) => theme.innerAlignBorder(theme.border.xs, theme.background.disabled)}
  }

  &:disabled:checked {
    ${({ theme }) => theme.innerAlignBorder('6px', theme.background.disabled)}
  }
`;

export const Label = styled.label`
  width: 100%;
  text-align: start;
  ${({ theme }) => theme.body.regular.md}
  color:   ${({ theme }) => theme.text.default}
`;
